import { render, staticRenderFns } from "./CourseImport.vue?vue&type=template&id=09afed6d&scoped=true"
import script from "./CourseImport.vue?vue&type=script&lang=ts"
export * from "./CourseImport.vue?vue&type=script&lang=ts"
import style0 from "./CourseImport.vue?vue&type=style&index=0&id=09afed6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09afed6d",
  null
  
)

export default component.exports